export const defaultEditorConfig = {
    "config": { //neaplikovano ve vue
        type: [Object],
        required: false,
        default: {
            attributes: {
                element_id_name: 'data-cms-element-id',
                element_typ_name: 'data-cms-element-type',
                element_values_name: 'data-cms-element-form-inputs',
            },
            action: {
                create: 'create',
                edit: 'edit',
                delete: 'delete',
            },
            timerObj: {
                mounted: null,
                renderDelay: null,
                onMounted: null,
                onClickLoadAttr: null,
                codeType: null,
                clearCode: null,
            },
            timer: {
                renderDelay: 10,
                onMounted: 5,
                onClickLoadAttr: 1,
                codeType: 500,
                clearCode: 750,
            }
        }
    },
    "buttonsDefinition": {
        type: [Object],
        required: false,
        default: {
            a: {
                title: 'wysiwyg.action.link.title' , //+ this.$t('wysiwyg.action.link.title')
                innerHtmlPlaceholder: true,
                ico: {
                    class: 'bi bi-link'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'a',
                params: {
                    href: {
                        value: null,
                        readonly: false,
                        default: null,
                    },
                    class: {
                        value: null,
                        readonly: false,
                        default: null,
                    },
                    target: {
                        value: null,
                        readonly: false,
                        default: '_self',
                    },
                },
                dialog: {
                    title: 'wysiwyg.action.link.dialog.title',
                    btn_footer: true,
                    inputs: {
                        href: {
                            title: 'wysiwyg.action.link.dialog.url.title',
                            type: 'text', // select, boolean, checkbox
                            isMandatory: true,
                            isRender: true,
                            //todo naplneni selectu1
                        },
                        target: {
                            title: 'wysiwyg.action.link.dialog.window.title',
                            type: 'select', // select, boolean, checkbox
                            isMandatory: true,
                            isRender: true,
                            defaultValue: '_blank',
                            select: {
                                '_self': {
                                    'title': 'wysiwyg.action.link.dialog.window.select.self'
                                },
                                '_blank': {
                                    'title': 'wysiwyg.action.link.dialog.window.select.blank'
                                },
                            }
                        },
                        note: {
                            title: 'wysiwyg.action.link.dialog.note.title',
                            type: 'text', // select, boolean, checkbox
                            isMandatory: false,
                            isRender: false,
                            //todo naplneni selectu1
                        },
                    },
                },
                help: 'wysiwyg.action.link.help',
            },
            strong: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.bold.title',
                ico: {
                    class: 'bi bi-type-bold'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'strong',
                params: {
                    /*
                    href: {
                      value: null,
                      readonly: false,
                      default: null,
                      isRender: false,
                    },
                    */
                    class: {
                        value: 'testovaci-trida',
                        readonly: false,
                        isRender: true,
                    },
                },
                help: 'wysiwyg.action.bold.help',
            },
            italic: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.italic.title',
                ico: {
                    class: 'bi bi-type-italic'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'i',
            },
            underline: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.underline.title',
                ico: {
                    class: 'bi bi-type-underline'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'u',
            },
            sup: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.sup.title',
                ico: {
                    class: 'bi bi-superscript'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'sup',
            },
            sub: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.sub.title',
                ico: {
                    class: 'bi bi-subscript'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'sub',
            },
            ul: {
                title: 'wysiwyg.action.ul.title',
                ico: {
                    class: 'bi bi-list-ul'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'ul',
                child: [
                    {
                        tagName: 'li',
                        innerHtmlPlaceholder: true,
                        _content: 'obsah',
                        params: {
                            class: 'first-li-filled'
                        },
                    },
                    {
                        tagName: 'li',
                        content: 'obsah druheho',
                        params: {
                            class: 'first-li-second'
                        },
                    },
                ],
                params: {
                },
                help: 'wysiwyg.action.ul.help',
            },
            ol: {
                title: 'wysiwyg.action.ol.title',
                ico: {
                    class: 'bi bi-list-ol'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'ol',
                child: [
                    {
                        tagName: 'li',
                        innerHtmlPlaceholder: true,
                        //_content: 'obsah',
                        params: {
                            class: 'first-li-filled'
                        },
                    },
                    {
                        tagName: 'li',
                        //content: 'obsah druheho',
                        params: {
                            class: 'first-li-second'
                        },
                    },
                ],
                params: {
                },
                help: 'wysiwyg.action.ol.help',
            },
            hr: {
                title: 'wysiwyg.action.hr.title',
                ico: {
                    class: 'bi bi-dash'
                },
                isActive: false,
                isDisabled: false,
                isWrap: false,
                tagName: 'hr',
                params: {
                    x: {
                        value: null,
                        readonly: false,
                        default: null,
                    }
                },
            },

            artist: {
                title: 'wysiwyg.action.artist.title',
                innerHtmlPlaceholder: true,
                ico: {
                    class: 'bi bi-person-raised-hand'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                help: 'wysiwyg.action.artist.help',
                dialog: {
                    title: 'Oznaceni umelce',
                    config: {
                        methods: {
                            paths: {
                                display: {
                                    //path: '/class/obsah/dev-wysiwig-editor-dialog',
                                    path: '/class/topic/list-search',
                                    method: 'post'
                                },
                                generate: {
                                    //path: '/class/obsah/wysiwig-editor-artist',
                                    path: '/class/topic/insert-topic-link',
                                    method: 'post'
                                },
                            },
                        },
                    },
                    btn_footer: false,
                    type: 'dynamic', // static | dynamic | null
                }
            },
            p_left: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.p_left.title',
                ico: {
                    class: 'bi bi-justify-left'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'p',
                params: {
                    style: {
                        value: 'text-align: left;',
                        readonly: false,
                        default: null,
                    },
                },
            },
            p_right: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.p_right.title',
                ico: {
                    class: 'bi bi-justify-right'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'p',
                params: {
                    style: {
                        value: 'text-align: right;',
                        readonly: false,
                        default: null,
                    },
                },
            },
            p_justify: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.p_justify.title',
                ico: {
                    class: 'bi bi-justify'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'p',
                params: {
                    style: {
                        value: 'text-align: justify;',
                        readonly: false,
                        default: null,
                    },
                },
            },
        }
    },
    "specialsDefinition": {
        type: [Object],
        required: false,
        default: {
            clearFormatComplete: {
                title: 'wysiwyg.action.clear_format_complete.title',
                ico: {
                    class: 'bi bi-eraser'
                },
                onClick: 'clearFormatComplete'
            },
            removeElement: {
                title: 'wysiwyg.action.remove_format_element.title',
                displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-x'
                },
                onClick: 'removeElementOther'
            },
            fullscreenToggleOn: {
                title: 'wysiwyg.action.fullscreen_toggle_on.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-fullscreen'
                },
                onClick: 'toggleFullscreen'
            },
            fullscreenToggleOff: {
                title: 'wysiwyg.action.fullscreen_toggle_off.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-fullscreen-exit'
                },
                onClick: 'toggleFullscreen'
            },
            search: {
                title: 'wysiwyg.action.search.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-search'
                },
                //special: true,
                //type: 'search',
                elements: [
                    {
                        element: 'input',
                        vModelName: 'searchAttr'
                    }
                ],
                onClick: 'switchSearchDisplay',
                help: 'wysiwyg.action.search.help'
            },
            switchEditorToCode: {
                title: 'wysiwyg.action.switch_editor_to_code.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-code'
                },
                onClick: 'switchEditor'
            },
            help: {
                title: '', //Help
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-question-circle'
                },
                onClick: 'switchHelp'
            },

        }
    }
};